import styled from 'styled-components'

export const RadioLabel = styled.label`
	display: flex;
	width: 100%;
	align-items: center;
	justify-content: space-between;
	padding: 5px 0;
	cursor: pointer;
	&:last-child {
		border-bottom: none;
	}
`
export const RadioCircle = styled.div`
	position: relative;
	width: 1.5rem;
	height: 1.5rem;
	border-radius: 50%;
	border: 2px solid ${props => props.theme.colors.brand.blueOmint};
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s ease;
`

export const RadioInner = styled.div`
	width: 0.75rem;
	height: 0.75rem;
	border-radius: 50%;
	background-color: ${props => props.theme.colors.brand.blueOmint};
	opacity: ${props => (props.checked ? 1 : 0)};
	transform: scale(${props => (props.checked ? 1 : 0)});
	transition: all 0.2s ease;
`

export const RadioButtonListContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`
